import { NgModule, Injectable } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { Observable } from 'rxjs';

import { CoreDialogModule } from '../core/core.module';
import { IScreenSizeService } from '../core/core';

import { CountdownDialogComponent, CountdownDialogOptions } from './countdown.dialogcomponent';

@Injectable()
export class CountdownDialogService {
    smallMediaSize: boolean;

    constructor(private matDialog: MatDialog, private mediaChange: IScreenSizeService) {
        this.smallMediaSize = this.mediaChange?.ScreenSize?.IsSmallDisplay || false;
    }

    // #region Close All Dialogs Service Call

    CloseAllDialogs(): void {
        this.matDialog.closeAll();
    }

    // #endregion

    // #region Open

    Open(options?: CountdownDialogOptions): Observable<boolean> {
        const self = this;

        const dlgoptions: CountdownDialogOptions = {
            disableClose: true,
            data: {
                TitleText: 'Please Wait...',
                MessageText: '',
                OKText: 'OK',
                CancelText: 'Cancel',
                Time: 60,
                ...options,
            },
            width: '500px',
            height: '18rem',
            maxHeight: '85vh',
        };

        if (self.smallMediaSize) {
            dlgoptions.width = '80vw';
            // dlgoptions.height = '80vh';
            dlgoptions.height = '30rem';
            dlgoptions.panelClass = 'smalldialogpanel';
        }

        const openHandle = this.matDialog.open<CountdownDialogComponent>(CountdownDialogComponent, dlgoptions);

        return openHandle.afterClosed();
    }

    // #endregion
}

@NgModule({
    imports: [CoreDialogModule, MatButtonModule, MatDialogModule, MatProgressBarModule],
    declarations: [CountdownDialogComponent],
    exports: [CountdownDialogComponent],
    providers: [CountdownDialogService],
})
export class CountdownDialogModule {}
